import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { catchAsync } from 'helpers';

export const updateUserById = createAsyncThunk(
  'users/updateUserById',
  catchAsync(async ({ id, data }, thunkAPI) => {
    const res = await axios.patch(`/users/${id}`, data);
    return res.data;
  })
);
